<template>
  <layout-workflow>
    <app-icon classes="mt-4 ml-4" @click="back()">arrow_back</app-icon>
    <manage-trial-notification-preferences />
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import ManageTrialNotificationPreferences from '@/components/notification-preferences/ManageTrialNotificationPreferences'
import { permissionsMixin } from '@/mixins/permissions'

export default {
  components: {
    LayoutWorkflow,
    ManageTrialNotificationPreferences
  },
  mixins: [permissionsMixin],
  methods: {
    back() {
      this.$router.push({
        name: 'account'
      })
    }
  }
}
</script>
